import "./PropsGroup.css"
import React, {JSX} from "react";

type Properties = {
    name: string
    children: Array<JSX.Element> | JSX.Element
}

function PropsGroup(props: Properties) {
    return <>
        <div className={"props-group-caption"}>
            {props.name}
        </div>
        {props.children}
    </>
}

export default PropsGroup